import { __assign } from "tslib";
import foundationColorTokens from './color-tokens';
import primitiveColorTokens from '../../tokens/colors';
import getSemanticColorTokens from './color-semantic-tokens';
import getComponentColorTokens from './color-component-tokens';
import borders from '../shared/borders';
import lighting from '../shared/lighting';
import getTypography from '../shared/typography';
import animation from '../shared/animation';
import breakpoints from '../shared/breakpoints';
import grid from '../shared/grid';
import mediaQuery from '../shared/media-query';
import sizing from '../shared/sizing';
export var LightTheme = {
    name: 'light-theme',
    colors: __assign(__assign(__assign(__assign({}, foundationColorTokens), primitiveColorTokens), getComponentColorTokens()), getSemanticColorTokens()),
    animation: animation,
    breakpoints: breakpoints,
    borders: borders,
    direction: 'auto',
    grid: grid,
    lighting: lighting,
    mediaQuery: mediaQuery,
    sizing: sizing,
    typography: getTypography(),
    // TODO(#2318) Remove it in the next v11 major version.
    // Do not use.
    zIndex: {
        modal: 2000,
    },
};
